import { isSupplyType } from "src/util/allocations";
import { getGroupType } from "src/util/groupType";

export type IsTeamInsightsAvailableArgs = {
  /** Team insights gate (`enableTeamInsights`, auto-on while org design is on). */
  insightsEnabled: boolean;
  team?:
    | {
        type?: string | null;
        isHidden?: boolean | null;
        isDeleted?: boolean | null;
      }
    | null
    | undefined;
  groupTypes?: Record<string, unknown> | null | undefined;
};

export const isTeamInsightsAvailableForTeam = ({
  insightsEnabled,
  team,
  groupTypes,
}: IsTeamInsightsAvailableArgs): boolean => {
  if (!insightsEnabled || !team?.type) {
    return false;
  }
  if (team.isHidden || team.isDeleted) {
    return false;
  }
  const groupType = getGroupType(team, groupTypes);
  // TPP-2132: demand teams use the same page, people only.
  return isSupplyType(groupType) || isDemandTeam(team, groupTypes);
};

export const isDemandTeam = (
  team: { type?: string | null } | null | undefined,
  groupTypes: Record<string, unknown> | null | undefined
): boolean => Boolean(getGroupType(team, groupTypes)?.isDemand);

/** Supply teams always get the full page. Demand teams need OD beta and the flag. */
export const isInsightsFullPage = ({
  team,
  groupTypes,
  odBetaEnabled,
  enableOrgInsights,
}: {
  team: { type?: string | null } | null | undefined;
  groupTypes: Record<string, unknown> | null | undefined;
  odBetaEnabled: boolean;
  enableOrgInsights?: boolean | null;
}): boolean =>
  !isDemandTeam(team, groupTypes) ||
  (odBetaEnabled && Boolean(enableOrgInsights));
